import dawn from '../assets/images/dawn.png';
import dusk from '../assets/images/dusk.png';
import forest from '../assets/images/forest.png';
import river from '../assets/images/river.png';
import moon from '../assets/images/moon.png';
import stars from '../assets/images/stars.png';
import centaurs from '../assets/images/centaurs.png';
import goblins from '../assets/images/goblins.png';
import merpeople from '../assets/images/merpeople.png';
import ghosts from '../assets/images/ghosts.png';
import vampires from '../assets/images/vampires.png';
import werewolves from '../assets/images/werewolves.png';
import trolls from '../assets/images/trolls.png';
import readMinds from '../assets/images/readMinds.png';
import invisibility from '../assets/images/invisibility.png';
import superHumanStrength from '../assets/images/superHumanStrength.png';
import speakToAnimals from '../assets/images/speakToAnimals.png';
import changeThePast from '../assets/images/changeThePast.png';
import changeAppearance from '../assets/images/changeAppearance.png';
import apparation from '../assets/images/apparation.png';
import transfiguration from '../assets/images/transfiguration.png';
import flying from '../assets/images/flying.png';
import hexes from '../assets/images/hexes.png';
import magicalCreatures from '../assets/images/magicalCreatures.png';
import everyArea from '../assets/images/everyArea.png';
import secrets from '../assets/images/secrets.png';
import left from '../assets/images/left.png';
import right from '../assets/images/right.png';
import piano from '../assets/images/piano.png';
import drum from '../assets/images/drum.png';
import violin from '../assets/images/violin.png';
import trumpet from '../assets/images/trumpet.png';
import findNoise from '../assets/images/findNoise.png';
import agreeWalk from '../assets/images/agreeWalk.png';
import admiration from '../assets/images/admiration.png';
import cold from '../assets/images/cold.png';
import cobble from '../assets/images/cobble.png';
import black from '../assets/images/black.png';
import white from '../assets/images/white.png';
import dark from '../assets/images/dark.png';
import diamonds from '../assets/images/diamonds.png';
import doctor from '../assets/images/doctor.png';
import dragonPoxCure from '../assets/images/dragonPoxCure.png';
import studentRecords from '../assets/images/studentRecords.png';
import merlinsBook from '../assets/images/merlinsBook.png';
import hunger from '../assets/images/hunger.png';
import loneliness from '../assets/images/loneliness.png';
import heads from '../assets/images/heads.png';
import tails from '../assets/images/tails.png';
import twisty from '../assets/images/twisty.png';
import sunny from '../assets/images/sunny.png';
import boredom from '../assets/images/boredom.png';
import great from '../assets/images/great.png';
import good from '../assets/images/good.png';
import wise from '../assets/images/wise.png';
import bold from '../assets/images/bold.png';
import ordinary from '../assets/images/ordinary.png';
import ignorant from '../assets/images/ignorant.png';
import selfish from '../assets/images/selfish.png';
import cowardly from '../assets/images/cowardly.png';
import beingIgnored from '../assets/images/beingIgnored.png';
import envied from '../assets/images/envied.png';
import liked from '../assets/images/liked.png';
import feared from '../assets/images/feared.png';
import imitated from '../assets/images/imitated.png';
import trusted from '../assets/images/trusted.png';
import praised from '../assets/images/praised.png';
import heights from '../assets/images/heights.png';
import eyeInTheDark from '../assets/images/eyeInTheDark.png';
import noFamily from '../assets/images/noFamily.png';
import sillySpeech from '../assets/images/sillySpeech.png';
import lie from '../assets/images/lie.png';
import askClassmate from '../assets/images/askClassmate.png';
import tellTheTruth from '../assets/images/tellTheTruth.png';
import attemptToConfuse from '../assets/images/attemptToConfuse.png';
import askWhat from '../assets/images/askWhat.png';
import suggestDrawing from '../assets/images/suggestDrawing.png';
import suggestThree from '../assets/images/suggestThree.png';
import standGround from '../assets/images/standGround.png';
import volunteerToFight from '../assets/images/volunteerToFight.png';
import caution  from '../assets/images/caution.png';
import bright from '../assets/images/bright.png';
import mysterious from '../assets/images/mysterious.png';
import chocolate from '../assets/images/chocolate.png';
import statue from '../assets/images/statue.png';
import blackBox from '../assets/images/blackBox.png';
import hideAndReview from '../assets/images/hideAndReview.png';
import tortoiseshell from '../assets/images/tortoiseshell.png';
import missYou from '../assets/images/missYou.png';
import dontCare from '../assets/images/dontCare.png';
import goldCasket from '../assets/images/goldCasket.png';
import pewterBox from '../assets/images/pewterBox.png';
import silverLeaf from '../assets/images/silverLeaf.png';
import redToadstools from '../assets/images/redToadstools.png';
import bubblingPool from '../assets/images/bubblingPool.png';
import tattle from '../assets/images/tattle.png';
import parchment from '../assets/images/parchment.png';
import sea from '../assets/images/sea.png';
import fire from '../assets/images/fire.png';
import home from '../assets/images/home.png';
import love from '../assets/images/love.png';
import glory from '../assets/images/glory.png';
import wisdom from '../assets/images/wisdom.png';
import power from '../assets/images/power.png';
import stories from '../assets/images/stories.png';
import agreeAsk from '../assets/images/agreeAsk.png';












export const questions = [


    {
        text: "Dawn or dusk?",
        options: [
            { 
                image: dawn, 
                houses: ["Gryffindor", "Ravenclaw"] 
            },
            { 
                image: dusk, 
                houses: ["Hufflepuff", "Slytherin"] 
            }
        ]
    },
    {
        text: "Forest or river?",
        options: [
            { 
                image: forest, 
                houses: ["Gryffindor", "Ravenclaw"] 
            },
            { 
                image: river, 
                houses: ["Hufflepuff", "Slytherin"] 
            }
        ]
    },
    {
        text: "Moon or stars?",
        options: [
            { 
                image: moon, 
                houses: ["Ravenclaw", "Slytherin"] 
            },
            { 
                image: stars, 
                houses: ["Gryffindor", "Hufflepuff"] 
            }
        ]
    },
    {
        text: "What would you most like to study?",
        options: [
            { 
                image: centaurs, 
                houses: ["Gryffindor", "Ravenclaw"] 
            },
            { 
                image: goblins, 
                houses: ["Ravenclaw", "Slytherin"] 
            },
            { 
                image: merpeople, 
                houses: ["Slytherin", "Hufflepuff" ] 
            },
            { 
                image: ghosts, 
                houses: ["Gryffindor","Ravenclaw"] 
            },
            { 
                image: vampires, 
                houses: ["Slytherin"] 
            },
            { 
                image: werewolves, 
                houses: ["Gryffindor"] 
            },
            { 
                image: trolls, 
                houses: ["Hufflepuff", "Slytherin"] 
            }
        ]
    },
    {
        text: "If you could have any power, which would you choose?",
        options: [
            {
                image: readMinds,
                houses: ["Ravenclaw", "Slytherin"]
            },
            {
                image: invisibility,
                houses: ["Gryffindor"]
            },
            {
                image: superHumanStrength,
                houses: ["Hufflepuff", "Slytherin" ]
            },
            {
                image: speakToAnimals,
                houses: ["Hufflepuff", "Ravenclaw"]
            },
            {
                image: changeThePast,
                houses: ["Slytherin", "Gryffindor"]
            },
            {
                image: changeAppearance,
                houses: ["Ravenclaw", "Gryffindor"]
            }
        ]
    },
    {
        text: "What are you most looking forward to learning at Hogwarts?",
        options: [
            {
                image: apparation,
                houses: ["Slytherin", "Gryffindor"]
            },
            {
                image: transfiguration,
                houses: ["Ravenclaw", "Hufflepuff"]
            },
            {
                image: flying,
                houses: ["Gryffindor", "Hufflepuff"]
            },
            {
                image: hexes,
                houses: ["Slytherin", "Ravenclaw", "Hufflepuff"]
            },
            {
                image: magicalCreatures,
                houses: ["Hufflepuff"]
            },
            {
                image: secrets,
                houses: ["Gryffindor", "Ravenclaw"]
            },
            {
                image: everyArea,
                houses: ["Ravenclaw", "Hufflepuff", "Gryffindor"]
            }
        ]
    },
    {
        text: `A troll has gone berserk in the Headmaster's study at Hogwarts. It is about to smash, crush and tear several irreplaceable items and treasures, including a cure for dragon pox, which the Headmaster has nearly perfected; student records going back 1000 years and a mysterious handwritten book full of strange runes, believed to have belonged to Merlin. Which  of these objects would you rescue first from the troll's club, if you could?`,
        options: [
            {
                image: dragonPoxCure,
                houses: ["Gryffindor", "Hufflepuff"]
            },
            {
                image: studentRecords,
                houses: ["Slytherin", "Gryffindor",]
            },
            {
                image: merlinsBook,
                houses: ["Ravenclaw", "Hufflepuff"]
            }
        ]
    },
    {
        text: `Which of the following do you find most difficult to deal with?`,
        options: [
            {
                image: hunger,
                houses: ["Ravenclaw", "Hufflepuff"]
            },
            {
                image: cold,
                houses: ["Slytherin", "Hufflepuff",]
            },
            {
                image: loneliness,
                houses: ["Gryffindor", "Hufflepuff"]
            },
            {
                image: boredom,
                houses: ["Gryffindor", "Slytherin"]
            },
            {
                image: beingIgnored,
                houses: ["Ravenclaw", "Slytherin",]
            }
        ]
    },
    {
        text: `Which would you rather be:`,
        options: [
            {
                image: envied, 
                houses: ["Slytherin", "Ravenclaw"] 
            },
            {
                image: imitated, 
                houses: ["Ravenclaw", "Gryffindor"] 
            },
            {
                image: trusted, 
                houses: ["Gryffindor", "Hufflepuff"] 
            },
            {
                image: praised, 
                houses: ["Gryffindor", "Slytherin"] 
            },
            {
                image: liked, 
                houses: ["Hufflepuff", "Gryffindor"] 
            },
            {
                image: feared, 
                houses: ["Slytherin", "Ravenclaw"] 
            }
        ]  
    },
    {
        text: `Which nightmare would frighten you most?`,
        options: [
            {
                image: heights, 
                houses: ["Ravenclaw"] 
            },
            {
                image: eyeInTheDark, 
                houses: ["Gryffindor"] 
            },
            {
                image: noFamily, 
                houses: ["Hufflepuff"] 
            },
            {
                image: sillySpeech, 
                houses: ["Slytherin"] 
            }
        ]
    },
    {
        text: `One of your house mates has cheated in a Hogwarts exam by using a Self-Spelling Quill. Now he has come top of the class in Charms, beating you into second place. Professor Flitwick is suspicious of what happened. He draws you to one side after his lesson and asks you whether or not your classmate used a forbidden quill. What do you do?`,
        options: [
            {
                image: lie, 
                houses: ["Hufflepuff"] 
            },
            {
                image: askClassmate, 
                houses: ["Gryffindor"] 
            },
            {
                image: tellTheTruth, 
                houses: ["Ravenclaw"] 
            },
            {
                image: tattle, 
                houses: ["Slytherin"] 
            }
        ]

    },
    {
        text: `You and two friends need to cross a bridge guarded by a river troll who insists on fighting one of you before he will let all of you pass. Do you:`,
        options: [
            {
                image: attemptToConfuse, 
                houses: ["Ravenclaw"] 
            },
            {
                image: suggestDrawing, 
                houses: ["Hufflepuff"] 
            },
            {
                image: suggestThree, 
                houses: ["Slytherin"] 
            },
            {
                image: volunteerToFight, 
                houses: ["Gryffindor"] 
            }
        ]
    },
    {
        text: `Late at night, walking alone down the street, you hear a peculiar cry that you believe to have a magical source. Do you:`,
        options: [
            {
                image: caution, 
                houses: ["Hufflepuff"] 
            },
            {
                image: findNoise, 
                houses: ["Gryffindor"] 
            },
            {
                image: standGround, 
                houses: ["Slytherin"] 
            },
            {
                image: hideAndReview, 
                houses: ["Ravenclaw"] 
            }
        ]
    },
    {
        text: `Which road tempts you most?`,
        options: [
            {
                image: sunny, 
                houses: ["Hufflepuff"] 
            },
            {
                image: dark, 
                houses: ["Slytherin"] 
            },
            {
                image: twisty, 
                houses: ["Gryffindor"] 
            },
            {
                image: cobble, 
                houses: ["Ravenclaw"] 
            }
        ]
    },
    {
        text: `A Muggle confronts you and says that they are sure you are a witch or wizard. Do you:`,
        options: [
            {
                image: askWhat, 
                houses: ["Ravenclaw"] 
            },
            {
                image: agreeAsk, 
                houses: ["Slytherin"] 
            },
            {
                image: agreeWalk, 
                houses: ["Gryffindor"] 
            },
            {
                image: doctor, 
                houses: ["Hufflepuff"] 
            }
        ]
    },
    {
        text: `Four goblets are placed before you. Which would you choose to drink?`,
        options: [
        {
                image: diamonds, 
                houses: ["Ravenclaw"] 
            },
            {
                image: chocolate, 
                houses: ["Hufflepuff"] 
            },
            {
                image: bright, 
                houses: ["Gryffindor"] 
            },
            {
                image: mysterious, 
                houses: ["Slytherin"] 
            }
        ]
    },
    {
        text: "Four boxes are placed before you. Which would you try and open?",
        options: [
            { 
                image: tortoiseshell, 
                houses: ["Hufflepuff"] 
            },
            { 
                image: blackBox, 
                houses: ["Slytherin"] 
            },
            { 
                image: goldCasket, 
                houses: ["Ravenclaw"] 
            },
            { 
                image: pewterBox, 
                houses: ["Gryffindor"] 
            }
        ]
    },
    {
        text: `What kind of instrument most pleases your ear?`,
        options: [
            { 
                image: violin, 
                houses: ["Slytherin"] 
            },
            { 
                image: trumpet, 
                houses: ["Hufflepuff"] 
            },
            { 
                image: piano, 
                houses: ["Ravenclaw"] 
            },
            { 
                image: drum, 
                houses: ["Gryffindor"] 
            }
        ]

    },
    {
        text: `You enter an enchanted garden. What would you be most curious to examine first?`,
        options: [
            { 
                image: silverLeaf, 
                houses: ["Ravenclaw"] 
            },
            { 
                image: redToadstools, 
                houses: ["Hufflepuff"] 
            },
            { 
                image: bubblingPool, 
                houses: ["Slytherin"] 
            },
            { 
                image: statue, 
                houses: ["Gryffindor"] 
            }
        ]

    },
    {
        text: `After you have died, what would you most like people to do when they hear your name?`,
        options: [
            { 
                image: missYou, 
                houses: ["Hufflepuff"] 
            },
            { 
                image: stories, 
                houses: ["Gryffindor"] 
            },
            { 
                image: admiration, 
                houses: ["Ravenclaw"] 
            },
            { 
                image: dontCare, 
                houses: ["Slytherin"] 
            }
        ]
    },
    {
        text: `Once every century, the Flutterby bush produces flowers that adapt their scent to attract the unwary. If it lured you, it would smell of:`,
        options: [
            { 
                image: fire, 
                houses: ["Gryffindor"] 
            },
            { 
                image: sea, 
                houses: ["Slytherin"] 
            },
            { 
                image: parchment, 
                houses: ["Ravenclaw"] 
            },
            { 
                image: home, 
                houses: ["Hufflepuff"] 
            }
        ]
    },
    {
        text: `Given the choice, would you rather invent a potion that would guarantee you:`,
        options: [
            { 
                image: love, 
                houses: ["Hufflepuff"] 
            },
            { 
                image: glory, 
                houses: ["Gryffindor"] 
            },
            { 
                image: wisdom, 
                houses: ["Ravenclaw"] 
            },
            { 
                image: power, 
                houses: ["Slytherin"] 
            }
        ]
    },
    {
        text: `Which of the following would you most hate people to call you?`,
        options: [
            { 
                image: ordinary, 
                houses: ["Slytherin"] 
            },
            { 
                image: ignorant, 
                houses: ["Ravenclaw"] 
            },
            { 
                image: cowardly, 
                houses: ["Gryffindor"] 
            },
            { 
                image: selfish, 
                houses: ["Hufflepuff"] 
            }
        ]
    },
    {
        text: `How would you like to be known to history?`,
        options: [
            { 
                image: wise, 
                houses: ["Ravenclaw"] 
            },
            { 
                image: good, 
                houses: ["Hufflepuff"] 
            },
            { 
                image: great, 
                houses: ["Slytherin"] 
            },
            { 
                image: bold, 
                houses: ["Gryffindor"] 
            }
        ]
    },
    {
        text: `Heads or tails?`,
        options:[
            { 
                image: heads, 
                houses: ["Hufflpuff", "Ravenclaw"] 
            },
            { 
                image: tails, 
                houses: ["Gryffindor", "Slytherin"] 
            }
        ]
    },
    {
        text: `Black or white?`,
        options: [
            { 
                image: black, 
                houses: ["Gryffindor", "Slytherin"] 
            },
            { 
                image: white, 
                houses: ["Hufflepuff", "Ravenclaw"] 
            }
        ]
    },
    {
        text: `Left or right?`,
        options: [
            { 
                image: left, 
                houses: ["Slytherin", "Ravenclaw"] 
            },
            { 
                image: right, 
                houses: ["Hufflepuff", "Gryffindor"] 
            }
        ]
    }
];